import Model from '@/models/Model'

export default class PosEmployeeSale extends Model {
    resource() {
        return 'pos_employee_sale'
    }
}